import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"

export default function Category() {
    const {
        response: { products },
        loading
    } = useAppState()

    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"

    // Pull collection description from Shopify theme if available
    const collectionDescription = typeof window !== 'undefined'
        ? document.querySelector('.hero__description')?.innerHTML
        : null

    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-font-inherit ns-mx-auto" id="Collection--template--nosto" data-section-id="template--nosto">
            <div class="collection__title collection__title--no-image align--middle-center">
                <h1 class="hero__title h4">{products?.categoryPath}</h1>
                {collectionDescription && (
                    <div
                        class="collection__description"
                        dangerouslySetInnerHTML={{ __html: collectionDescription }}
                    />
                )}
            </div>

            <Toolbar lableFor={toggleButtonId} />
            
            <div class="ns-d-flex ns-w-100 ns-border-box">
                {foundProducts ? (
                    <div class="collection__products">
                        <Sidebar toggleId={toggleButtonId} />
                        <Products />
                    </div>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}
            </div>
            
            <Pagination />
        </div>
    )
}
    